module.exports = __webpack_public_path__ + "static/media/bahador.74e36af1.jpg";